<template>
  <div class="card card-graph flex-fill">
    <div class="card-header d-flex justify-content-between">
      <h5 class="card-title mb-0">{{ title }}</h5>
      <router-link
        v-if="historyLink"
        :to="{ name: 'analytics-dashboard-component', params: { deviceId: devId, componentname: 'disk-utilization' } }"
        class="btn btn-primary btn-sm d-flex align-items-center gap-1"
      >
        <i class="bx bx-history"></i>
        History
      </router-link>
    </div>
    <div class="card-body">
      <div class="graph d-flex flex-wrap flex-col justify-content-center" ref="graphRef">
        <div class="d-flex flex-col justify-content-center" ref="charRef" style="height: 290px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 1024px) {
}

.graph {
  min-height: 300px;
  min-width: 200px;
  align-items: top;
}
</style>

<script>
import { onMounted, onUnmounted, onBeforeMount, onBeforeUnmount, ref, computed, watch } from 'vue'
import axios from 'axios'
import * as echarts from 'echarts'
import { useStore } from 'vuex'
import { getChartOptions } from '@/data/diskchart.data'
import { createQuery } from '@/data/createDiskUsageQuery'

export default {
  name: 'GraphDiskUsage',
  props: {
    host: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },

    terms: {
      type: Array,
      default: function () {
        return ['shortterm', 'midterm', 'longterm']
      },
    },
    refresh: {
      type: Number,
      default: 30,
    },
    title: {
      type: String,
      default: 'Disk Utilization',
      required: false,
    },
    devId: {
      type: [String, Number],
      default: 0,
    },
    historyLink: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    //const orgID = '1b0f79e17233c082'
    const timer = ref(null)
    const chart = ref(null)

    const charRef = ref(null)
    const graphRef = ref(null)
    const graphValue = ref(0)

    const dataArray = ref({})

    const store = useStore()

    const layoutMode = computed(() => store.state.layout.layoutMode)
    const apiKey = computed(() => store.state.auth.user?.accessToken)
    const apiHost = computed(() => window.apiHost)
    //const apiOrgId = computed(() => store.state.config.apiOrgId);

    const resizeObserver = new ResizeObserver(() => {
      onWindowResize()
    })

    // Watch for changes in layoutMode
    watch(layoutMode, (newMode) => {
      if (chart.value !== null) {
        const theme = newMode === 'dark' ? 'dark' : 'light'
        chart.value.dispose()
        chart.value = echarts.init(charRef.value, theme)
        drawChart(graphValue.value, dataArray.value)
      }
    })

    async function drawChart(value, data) {
      graphValue.value = value
      var option = getChartOptions(data)
      option.backgroundColor = layoutMode.value === 'dark' ? '#22354e' : '#ffffff'
      chart.value.setOption(option, { replaceMerge: ['series', 'graphic'] })
    }

    function initChart() {
      if (chart.value === null) {
        var theme = 'light'
        if (layoutMode.value === 'dark') {
          theme = 'dark'
        }
        chart.value = echarts.init(charRef.value, theme)
      }

      var option = getChartOptions({})
      option.backgroundColor = layoutMode.value === 'dark' ? '#22354e' : '#ffffff'
      chart.value.setOption(option, { replaceMerge: ['series', 'graphic'] })
    }

    async function main() {
      try {
        var terms = props.terms
        if (terms === null || terms.length == 0) {
          terms = ['shortterm']
        }
        const query = createQuery(props.host, props.type)
        //console.log("Type is Disk:",props.type);
        //console.log('Flux Query:\n', query)
        const response = await axios.post(apiHost.value + '/core/api/v1/analytics/query', query, {
          headers: {
            Authorization: 'Bearer ' + apiKey.value,
            'Content-Type': 'application/vnd.flux',
            Accept: 'application/csv',
          },
        })
        var data = response.data
        var lines = -1
        var value = 0
        data.split('\n').forEach((line) => {
          if (++lines > 0) {
            var fields = line.trim().split(',')
            if (fields.length > 12) {
              var fName = fields[12]
              if (props.type === 'snmp' && (fName.substring(0, 1) == '/' || (fName.length > 3 && fName.substring(0, 4).toLowerCase() == 'swap'))) {
                dataArray.value[fName] = parseInt(fields[6])
              } else if (props.type != 'snmp' && (fName.substring(0, 1) != '/' || (fName.length > 3 && fName.substring(0, 4).toLowerCase() == 'swap'))) {
                dataArray.value[fName] = parseInt(fields[6])
              }
            }
          }
        })

        drawChart(value, dataArray.value)
      } catch (error) {
        console.error(error)
      }
    }

    function onWindowResize() {
      if (chart.value !== null) {
        chart.value.resize()
      }
    }

    onMounted(() => {
      initChart()
      main()

      if (props.refresh > 0) {
        timer.value = setInterval(() => {
          //main();
        }, props.refresh * 1000)
      }

      if (graphRef.value) {
        resizeObserver.observe(graphRef.value)
      }
    })

    onUnmounted(() => {
      if (props.refresh > 0 && timer.value !== null) {
        clearInterval(timer.value)
      }
    })

    onBeforeMount(() => {
      window.addEventListener('resize', onWindowResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', onWindowResize)
      resizeObserver.unobserve(graphRef.value)
    })

    return {
      charRef,
      graphRef,
      main,
    }
  },
}
</script>
